import React from 'react'
import NewSalarySummaryComponent from './newSalarySummary.component'
import NewSalarySelectComponent from './newSalarySelect.component'
import NewSalaryInfoComponent from './newSalaryInfo.component'
import { Translation } from 'react-i18next'
export default class PaySalaryComponent extends React.Component {
  componentDidMount() {
    this.props.getReferralDiscountByEmail(this.props.selectedUser)
  }

  render() {
    return <PaySalary {...this.props} />
  }
}

const PaySalary = ({
  getNewSalaryStart,
  selectRowSalary,
  newSalarySummary,
  taxPercent,
  selectedRows,
  newSalary,
  postSalary,
  salaries,
  warnToAddCost,
  cancelPaySalary,
  isSalaryInfo,
  newSalaryInfo,
  warnNoSSN,
  showDialog,
  closeDialogSalary,
  willGetDiscount,
  sendReferralCode,
  referrerPersonGetDiscount,
  recommendedPersonGetDiscount,
  discount,
  allSalaries,
  sendCodeSuccess,
  sendCodeFailed,
  nerverUseDiscount,
  closeSalarySnackbar,
  handleRefreshClick,
  isCodeActivated,
  selectedUser
}) => (
  <Translation>
    {(t) => {
      return (
        <div className="container-fluid">
          <div className="row">
            <div className="dashboard-content-header">
              <h1>{t('newSalarySummary.h1')}</h1>
            </div>
          </div>
          <div className="row"></div>
          <div>
            <h5>{t('newSalary.pp')}</h5>
          </div>
          <div>
            <h5>{t('newSalary.groupInvoice')}</h5>
          </div>
          <div className="row">
            <div className="dashboard-content-header">
              <div className="col-md-6 col-sm-6">
                <div className="panel panel-default">
                  <div className="panel-heading">
                    <h3 className="panel-title">
                      {t('newSalarySummary.paySalary')}
                    </h3>
                  </div>
                  <NewSalarySelectComponent
                    getNewSalaryStart={getNewSalaryStart}
                    newSalary={newSalary}
                    selectRowSalary={selectRowSalary}
                    selectedRows={selectedRows}
                    willGetDiscount={willGetDiscount}
                    referrerPersonGetDiscount={referrerPersonGetDiscount}
                    recommendedPersonGetDiscount={recommendedPersonGetDiscount}
                    selectedUser={selectedUser}
                  />
                </div>
                {/* KAS-336 Show info how discount is */}
                {willGetDiscount && newSalary.length > 1 ? (
                  <div className="red panel panel-default">
                    <p
                      style={{
                        padding: '10px',
                        outline: '1px solid #F67131',
                        borderRadius: '2px'
                      }}
                    >
                      {t('referral.note1')}
                    </p>
                  </div>
                ) : referrerPersonGetDiscount && newSalary.length > 0 ? (
                  <div className="red panel panel-default">
                    <p
                      style={{
                        padding: '10px',
                        outline: '1px solid #F67131',
                        borderRadius: '2px'
                      }}
                    >
                      {t('referral.note2')}
                    </p>
                  </div>
                ) : null}
              </div>
            </div>
            {selectedRows.length > 0 ? (
              <NewSalarySummaryComponent
                newSalarySummary={newSalarySummary}
                taxPercent={taxPercent}
                postSalary={postSalary}
                selectedRows={selectedRows}
                salaries={salaries}
                warnToAddCost={warnToAddCost}
                cancelPaySalary={cancelPaySalary}
                warnNoSSN={warnNoSSN}
                showDialog={showDialog}
                closeDialogSalary={closeDialogSalary}
                sendReferralCode={sendReferralCode}
                allSalaries={allSalaries}
                sendCodeSuccess={sendCodeSuccess}
                sendCodeFailed={sendCodeFailed}
                nerverUseDiscount={nerverUseDiscount}
                closeSalarySnackbar={closeSalarySnackbar}
                discount={discount}
                handleRefreshClick={handleRefreshClick}
                isCodeActivated={isCodeActivated}
              />
            ) : (
              <div />
            )}
            {isSalaryInfo && selectedRows.length <= 0 ? (
              <NewSalaryInfoComponent newSalaryInfo={newSalaryInfo} />
            ) : (
              <div />
            )}
          </div>
        </div>
      )
    }}
  </Translation>
)
